<template>
  <a-modal
    title="房间导入"
    :visible="visible"
    :confirmLoading="submitting"
    cancelText="关闭"
    destroyOnClose
    :maskClosable="false"
    :okButtonProps="{
      style:{
         display: 'none'
      }
    }"
    @cancel="$emit('update:visible', false)"
  >
    <a-form :form="form">
      <a-form-item label="下载模板" v-bind="formItemLayout">
        <a-button type="primary"  @click="excelDown">下载房间模板</a-button>
      </a-form-item>
      <a-form-item label="上传模板" v-bind="formItemLayout">
          <upload-file :fileList.sync="fileList" :title="title" :disabled="false" :max="1" :type='2' @submitted="successData" @errorLoad="downLoadError"></upload-file>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import downloadFile from '../../../utils/download.js'
import UploadFile from '../../../components/UploadFile'
export default {
  name: 'DialogRoomImport',

  beforeCreate () {
    this.formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 15 }
    }
  },

  props: {
    visible: Boolean
  },
  components: {
    UploadFile
  },
  watch: {
  },

  data () {
    return {
      submitting: false,
      title: '导入房间',
      fileList: [],
      form: this.$form.createForm(this)
    }
  },

  methods: {
    async successData () {
      this.$emit('update:visible', false)
      this.$message.success('导入成功!')
      this.$emit('submitted')
    },
    async excelDown () {
      await downloadFile('/excel/download', { 'excelName': '房产批量导入.xls' })
    },
    async downLoadError (url) {
      if (!url) {
        return false
      }
      this.$confirm({
        title: '导入房间数据',
        content: '对不起，批量导入数据有误，请下载错误信息！?',
        onOk: async () => {
          await downloadFile('/excel/download/error', { 'excelName': url })
        },
        onCancel () {}
      })
    }
  }
}
</script>

<style lang="less" scoped>
</style>
